<template>
  <div class="slideshow">
    <transition name="fade">
      <div class="stage">
        <img src="/assets/venue-1.png" />
      </div>
    </transition>
    <transition name="fade">
      <div class="content">
        <p v-for="(sponsor, index) in sponsors" :key="index">
          <a :href="sponsor.url" target="_new">
            <img
              :src="sponsor.image"
              :alt="'Bild unseres Sponsors ' + sponsor.name"
              :title="sponsor.name"
              width="260"
            />
          </a>
        </p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Sponsors",
  props: {
    msg: String,
  },

  data() {
    return {
      sponsors: [
        {
          name: "Allgäuer Überlandwerk GmbH",
          url: "https://www.auew.de",
          image: "/assets/sponsor-1.png",
        },
        {
          name: "f+p THERAPIE",
          url: "https://fp-kempten.de",
          image: "/assets/sponsor-2.png",
        },
        {
          name: "Markt Oberstaufen",
          url: "https://www.oberstaufen.de",
          image: "/assets/sponsor-3.png",
        },
        {
          name: "Hündlebahn | Imbergbahn Skiarena",
          url: "https://www.huendle-imberg.de",
          image: "/assets/sponsor-15.png",
        },
        {
          name: "pur group GmbH",
          url: "https://www.pur-group.de",
          image: "/assets/sponsor-4.png",
        },
        {
          name: "Sport Hauber",
          url: "https://www.sport-hauber.de",
          image: "/assets/sponsor-5.png",
        },
        {
          name: "Stadt Sonthofen",
          url: "https://stadt-sonthofen.de",
          image: "/assets/sponsor-6.png",
        },
        {
          name: "Edelrid",
          url: "https://www.edelrid.de",
          image: "/assets/sponsor-7.png",
        },
        {
          name: "SCALTEL AG",
          url: "https://www.scaltel.de",
          image: "/assets/sponsor-8.png",
        },
        {
          name: "Markt Oberstdorf",
          url: "https://www.markt-oberstdorf.de",
          image: "/assets/sponsor-9.png",
        },
        {
          name: "Exploryx",
          url: "https://www.exploryx.de/",
          image: "/assets/sponsor-10.png",
        },
        {
          name: "ZRF",
          url: "https://zrf-allgaeu.de",
          image: "/assets/sponsor-11.png",
        },
        {
          name: "Bergwacht Bayern",
          url: "https://www.bergwacht-bayern.de",
          image: "/assets/sponsor-12.png",
        },
        {
          name: "Markt Hindelang",
          url: "https://www.badhindelang.de",
          image: "/assets/sponsor-13.png",
        },
        {
          name: "Stiftung Bergwacht Bayern",
          url: "http://www.stiftung-bergwacht.org",
          image: "/assets/sponsor-14.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: space-between;
}

.content p {
  margin: 0 5px 0 0;
}

@media screen and (max-width: 800px) {
  .content {
    justify-content: center;
  }
}
</style>
